// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const YAxisRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="YAxisRightIcon" ref={forwardedRef} {...props}>
      <path d="M4.25 3v1.5h-1.5V3z" />
      <path d="M15.25 3v14H16a1 1 0 0 0 1-1V3z" />
      <path d="M13.499 15.5h-1.5V17h1.5z" />
      <path d="M9 15.5h1.5V17H9z" />
      <path d="M7.25 15.5h-1.5V17h1.5z" />
      <path d="M2.75 15.5h1.5V17h-.5a1 1 0 0 1-1-1z" />
      <path d="M4.25 13.749v-1.5h-1.5v1.5z" />
      <path d="M4.25 9.25v1.5h-1.5v-1.5z" />
      <path d="M4.25 7.5V6h-1.5v1.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const YAxisRightIcon = /* @__PURE__ */ Object.assign(
  YAxisRightIconComponent,
  { displayName: 'YAxisRightIcon' },
);
